import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en/translation.json';
import pl from './locales/pl/translation.json';
import fr from './locales/fr/translation.json';
import es from './locales/es/translation.json';
import zh from './locales/zh/translation.json';
import uk from './locales/uk/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: en,
      },
      pl: {
        translation: pl,
      },
      fr: {
        translation: fr,
      },
      es: {
        translation: es,
      },
      zh: {
        translation: zh,
      },
      uk: {
        translation: uk,
      },
    },
  });

export default i18n;
